import React, { useRef } from 'react';
import FractionalHeroSection from '../../../components/landingPage/FractionalPage/FractionalHeroSection';
import FractionalStatBand from '../../../components/landingPage/FractionalPage/FractionalStatBand';
import FractionHelpSection from '../../../components/landingPage/FractionalPage/FractionHelpSection';
import FractionalCarouselSection from '../../../components/landingPage/FractionalPage/FractionalCarouselSection';
import FractionalProcessSection from '../../../components/landingPage/FractionalPage/FractionalProcessSection';
import FractionalCtaSection from '../../../components/landingPage/FractionalPage/FractionalCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const Fractional = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <FractionalHeroSection />
            <FractionalStatBand />
            <FractionHelpSection />
            <FractionalCarouselSection />
            <FractionalProcessSection />
            <FractionalCtaSection />
        </div>
    );
};

export default Fractional;
